<template>
  <div class="w-full" v-if="isCardActiveLocal">
    <div class="vx-row">
      <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
        <user-details :loading="loadingDetails" :userDetails="userDetails" :myTime="userDetailsObject.timeSpentAvgStudent" :avgTime="userDetailsObject.timeSpentAvgGrade" :radialData="[userDetailsObject.scoreAvgStudent,userDetailsObject.scoreAvgGrade]"/>
      </div>
    </div>
    <div class="flex mb-2" style="justify-content: space-between;">
      <div class="flex" style="align-items: center;">
        <h4 style="margin-bottom: 0;">Subjects</h4>
      </div>
      <vx-input-group class="input-group-with-input-for-filtering ml-4" style="">
        <template slot="prepend">
          <div class="prepend-text ">
            <span><feather-icon class="pt-1" icon="SearchIcon" svg-classes="stroke-current h-5 w-5"></feather-icon></span>
          </div>
        </template>

        <vs-input class="dashboard-filter-input" placeholder="Search here..." v-model="subjectFilterText"/>
      </vx-input-group>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
        <div v-if="!loadingDataCards" class="vx-row data-card-container">
          <div class="vx-col mb-3" v-for="(subject, index) in subjects" :key="index" style="padding-left: 0; padding-right: 0;">
            <data-card :smallText="true" class="mx-2" @handleSubjectClick="selectedSubject(subject)" type="Subject" :title="subject.subjectName" :myTime="subject.timeSpentAvgStudent" :avgTime="subject.timeSpentAvgGrade" :radialData="[subject.scoreAvgStudent, subject.scoreAvgGrade]"/>
          </div>          
        </div>
        <div v-if="loadingDataCards" class="vx-row data-card-container">
          <div class="vx-col w-full mb-3" style="padding-left: 0; padding-right: 0;">
            <data-card-skeleton :count="4"/>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <line-chart :isLoading="loadingChartsTime" @filterDropdownChanged="filterDropdownChangedStudentGraphTimeSpent" :series="timeSpentSeries" :title="'Time Spent'" :filterList="listOfSubjectsForDropdown"/>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <line-chart :isLoading="loadingChartsScore" @filterDropdownChanged="filterDropdownChangedStudentGraphScore" :series="scoreSeries" :title="'Score'" :filterList="listOfSubjectsForDropdown"/>
      </div>
    </div>
  </div>
</template>


<script>
import vSelect from 'vue-select'
import DataCard from './DataCard.vue'
import UserDetails from './UserDetails.vue'
import CustomSkeleton from './CustomSkeleton.vue'
import DataCardSkeleton from './DataCardSkeleton.vue'
import LineChart from './LineChart.vue';
export default {
  name: "Subjects",
  components: {
    vSelect,
    DataCard,
    UserDetails,
    CustomSkeleton,
    DataCardSkeleton,
    LineChart,
  },
  props: {
    isCardActive: {
      type: Boolean,
      required: true
    },
    userDetails:{
      type:Object,
      required: true
    }
  },
  data() {
    return {
      loadingDetails:true,
      loadingDataCards:true,
      loadingChartsScore:true,
      loadingChartsTime:true,
      subjects: [],
      originalSubjects: [],
      subjectFilterText: "",
      listOfSubjectsForDropdown: [],
      scoreSeries:[],
      timeSpentSeries:[],
      userDetailsObject:{},
    };
  },
  watch: {
    isCardActive: function(val) {
      var self = this;
      if(val){
        self.userDetails.selectedSubject = {};
        self.getSubjects();
        self.fetchUserDetails();
        localStorage.setItem("Guardian_Position",JSON.stringify(self.userDetails));
        localStorage.setItem("Active_Card","1");
      }
    },
    subjectFilterText: function(val) {
      var self = this;
      if(val) {
        self.subjects = self.originalSubjects.filter(function(x) { return x.name.toLowerCase().includes(val.toLowerCase()) });
      } else {
        self.subjects = self.originalSubjects;
      }
    }
  },
  computed: {
    isCardActiveLocal: {
      get() {
        return this.isCardActive;
      },
      set(val) { }
    },
  },
  methods: {
    getSubjects() {
      var self = this;

      self.loadingDetails = true;
      self.loadingDataCards = true;

      var onSuccess = function(response) {
        self.subjects = response.data;
        self.listOfSubjectsForDropdown = self.subjects.map((item) => {return { label: item.subjectName, value: item.subjectId }});

        self.originalSubjects = self.subjects;
      };

      var onFinally = function() {
        self.loadingDataCards = false;
        self.loadingChartsTime = false;
        self.loadingChartsScore = false;
      };

      self.$ajaxGet(self, `GuardianDashboard/ListStudentSubjects?userId=${self.userDetails.id}&gradeId=${self.userDetails.gradeId}`, onSuccess, onFinally);
    },
    selectedSubject(subject){
      this.$emit('selectedSubject', subject);
      this.userDetails.selectedSubject = subject;
    },
    filterDropdownChangedStudentGraphTimeSpent(courseName,courseId,selectedDate) {
      var self = this;
      this.loadingChartsTime = true;
      var onSuccess = response =>{
        self.timeSpentSeries = [
          {
            name: "Single Student Avg.",
            data: response.data.avaragesList,
          },
          {
            name: "Combined Student Avg.",
            data: response.data.timeSpentAvaragesList
          }
        ];
      }
      var onFinally = response =>{
        self.loadingChartsTime = false;
      }
    
      self.$ajaxGet(self, `GuardianDashboard/StudentGraphTimeSpent?studentId=${this.userDetails.id}&month=${selectedDate.monthIndex}&year=${selectedDate.year}&courseId=${courseId}` , onSuccess, onFinally);
    },
    filterDropdownChangedStudentGraphScore(courseName,courseId,selectedDate) {
      var self = this;
      this.loadingChartsScore = true;
      var onSuccess = response =>{
        self.scoreSeries = [
          {
            name: "Single Student Avg.",
            data: response.data.scoreList,
          },
          {
            name: "Combined Student Avg.",
            data: response.data.scoreListAvg,
          },
        ];
      }
    
      var onFinally = response =>{
        self.loadingChartsScore = false;
      }
      self.$ajaxGet(self, `GuardianDashboard/StudentGraphScore?studentId=${this.userDetails.id}&month=${selectedDate.monthIndex}&year=${selectedDate.year}&courseId=${courseId}` , onSuccess, onFinally);
    },
    fetchUserDetails() {
      var self = this;
      this.loadingDetails = true;
      var onSuccess = response =>{
        self.userDetailsObject = response.data;
        self.loadingDetails = false;
      }
      var onFinally = response =>{
        self.loadingDetails = false;
      }
    
      self.$ajaxGet(self, `GuardianDashboard/UserDetailsForDashboard?userId=${this.userDetails.id}&gradeId=${self.userDetails.gradeId}` , onSuccess, onFinally);
    },
  },
  created() {
    var self = this;
    
  },
  mounted() {
    var self = this;
  }
};
</script>


<style lang="scss">
  @media screen and(max-width:678px){
    .data-card-container{
      justify-content: center;
    }
    .skeleton-loading-card{
      justify-content: center;
      padding: 20px;
    }
    .data-card-outline{
      margin-right: 0px !important;
    }
  }
</style>